import type { VoidFunctionComponent } from 'react';
import { useGetCurrentPlan } from '../../../../hooks/subscriptions/useGetCurrentPlan';
import Loader from '../../../generic/Loader';
import Flex from '../../../generic/Flex';
import PlanDetails from './PlanDetails';
import PlanInfo from './PlanInfo';

const CurrentPlan: VoidFunctionComponent = () => {
  const {
    data,
    isLoading,
  } = useGetCurrentPlan();

  if (isLoading) {
    return (<Loader />);
  }

  if (!data) {
    return null;
  }

  return (
    <Flex direction="column" gap={32} align="unset">
      <PlanInfo data={data} />
      <PlanDetails data={data} />
    </Flex>
  );
};

export default CurrentPlan;
